import { io } from "socket.io-client";
import Config from "../utils/Config";


class SocketService {
    socket = null;

    init(backendUrl = null, token = null, companyId = null) {
        
        this.disconnect();

        const url = backendUrl;
        this.socket = io(url, {
            path: Config.WS_PATH,
            auth: {
                authorization: token,
                companyId: companyId
            },
            reconnectionAttempts: 5,
            reconnectionDelay: 2000,
            reconnectionDelayMax: 10000,
        });
        
        this.socket.on('connect_error', (err) => {
            if (err.message?.includes('auth') || err.message?.includes('token') || err.message?.includes('jwt')) {
                console.warn('Socket auth failed, stopping reconnection:', err.message);
                this.socket.disconnect();
            }
        });
    }

    sendMessage(groupId, message) {
        console.table({...message,groupId});
        this.socket.emit('sendGroupMessage', { groupId, message });
    }

    deleteMessage(groupId, messageId) {
        this.socket.emit('deleteGroupMessage', { groupId, messageId });
    }

    joinGroup(groupId) {
        this.socket.emit('joinGroup', groupId);
    }

    leaveGroup(groupId) {     
        if(!this.socket) return;
        this.socket.emit('leaveGroup', groupId);
    }

    onMessage(callback) {
        this.socket.on('receiveGroupMessage', callback);
    }

    onMessageDeleted(callback) {
        this.socket.on('groupMessageDeleted', callback);
    }

    onChatListUpdate(callback) {
        this.socket.on('chatListUpdate', callback);
    }

    cleanup() {
        if (!this.socket) return;
        this.socket.off('receiveGroupMessage');
        this.socket.off('groupMessageDeleted');
        this.socket.off('chatListUpdate');
    }

    disconnect() {
        if (this.socket) {
            this.socket.removeAllListeners();
            this.socket.disconnect();
            this.socket = null;
        }
    }
}

export default new SocketService();
